var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/components/x-buildify-spacing-picker.ts
import { RXController } from "@adornis/chemistry/controllers/RXController.js";
import { css } from "@adornis/chemistry/directives/css.js";
import { injectAttributesOf } from "@adornis/chemistry/directives/inject-attributes.js";
import "@adornis/chemistry/elements/components/x-button.js";
import "@adornis/chemistry/elements/components/x-flex.js";
import "@adornis/chemistry/elements/components/x-icon.js";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import "@adornis/fonts/fonts.js";
import "@adornis/forms/x-input.js";
import "@adornis/popover/x-dropdown-selection.js";
import { html, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";
import { ifDefined } from "lit/directives/if-defined.js";
import {
  splitSpacingString,
  validSpacingUnits
} from "../../db/GlobalSettings.js";
import { XBuildifyGlobalSettingsFormField } from "./x-buildify-global-settings-formfield.js";
var XBuildifySpacingPicker = class extends XBuildifyGlobalSettingsFormField {
  constructor() {
    super(...arguments);
    this.select = new RXController(this, false);
  }
  render() {
    const content = this.content();
    if (content === nothing)
      return content;
    return xComponents(content);
  }
  content() {
    const distanceObj = splitSpacingString(this.value.value);
    if (!this.unit?.length && this.select.value && this._consumedGlobalSettingsClassName.value)
      return this._selectable();
    return this._freeForm(distanceObj);
  }
  _freeForm(distanceObj) {
    return html`
      <x-flex space="xs" center h100>
        <x-flex horizontal crossaxis-end space="xs">
          <x-input
            flex
            type="number"
            placeholder=${this.placeholder ?? "Distanz"}
            @value-picked=${(e) => {
      this._commitValue({ number: e.detail.value, unit: this.unit ?? distanceObj.unit });
    }}
            .value=${distanceObj.number}
            error=${ifDefined(this.error)}
          >
          </x-input>
          ${this.unit?.length ? html`
                <x-flex ${css({ minWidth: "75px", alignItems: "center", justifyContent: "center", height: "100%" })}>
                  <x-text ${css({ textAlign: "center" })}> ${this.unitTranslation ?? this.unit} </x-text>
                </x-flex>
              ` : html`
                <x-dropdown-selection
                  ${css({ minWidth: "75px" })}
                  placeholder="Einheit"
                  placeholder-mode="hide"
                  .selectables=${validSpacingUnits}
                  @value-picked=${(e) => {
      this._commitValue({ number: distanceObj.number, unit: e.detail.value });
    }}
                  .value=${distanceObj.unit}
                ></x-dropdown-selection>
              `}
        </x-flex>
      </x-flex>
    `;
  }
  _selectable() {
    if (!this._globalSettings.value)
      return nothing;
    return html`
      <x-dropdown-selection
        ${injectAttributesOf(this)}
        .selectables=${this._globalSettings.value?.spacings}
        .value=${this._globalSettings.value?.spacings?.find((spacing) => spacing.spacing === this.value.value)}
        .renderString=${(spacingDef) => spacingDef?.name ?? ""}
        @value-picked=${(e) => e.detail.value ? this._commitValue(splitSpacingString(e.detail.value.spacing)) : this._commitValue()}
      ></x-dropdown-selection>
    `;
  }
  _commitValue(valueObj) {
    if (!valueObj)
      this.value.next(null);
    else
      this.value.next(`${valueObj.number ?? ""}${valueObj.unit ?? ""}`);
    this.dispatchEvent(new CustomEvent("value-picked", { detail: { value: this.value.value } }));
  }
  get configuration() {
    return {
      icons: {
        advancedSettings: "tune"
      }
    };
  }
};
__decorateClass([
  property()
], XBuildifySpacingPicker.prototype, "placeholder", 2);
__decorateClass([
  property({ type: Boolean })
], XBuildifySpacingPicker.prototype, "select", 2);
__decorateClass([
  property()
], XBuildifySpacingPicker.prototype, "unit", 2);
__decorateClass([
  property({ attribute: "unit-translation", type: String })
], XBuildifySpacingPicker.prototype, "unitTranslation", 2);
XBuildifySpacingPicker = __decorateClass([
  customElement("x-buildify-spacing-picker")
], XBuildifySpacingPicker);
export {
  XBuildifySpacingPicker
};
